import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  GetAnalyticsDto,
  RoomUsageListResponse,
} from "@classview/shared-types";
import {
  UseQueryOptions,
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

export const getRoomUsageList = async ({
  from,
  to,
  organisationId,
}: GetAnalyticsDto) => {
  const response = await axiosClient.get<RoomUsageListResponse>(
    `/analytics/room-usage-list`,
    { params: { from, to, organisationId } },
  );

  return response.data;
};

export function useGetRoomUsageList(
  { from, to, organisationId }: GetAnalyticsDto,
  queryOptions?: Partial<UseQueryOptions<RoomUsageListResponse, HttpError>>,
) {
  return useQuery({
    queryKey: ["analytics", "room-usage-list", from, to, organisationId],
    queryFn: () => getRoomUsageList({ from, to, organisationId }),
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
}
